import { call, select, take, all, put } from "redux-saga/effects";
import { subscriptionPreferencesAT } from "../../subscriptionPreferences/SubscriptionPreferencesModel";
import { getJsonSaga } from "../_services/apiCalls";
import { IState } from "@common/state/IState";
import {
    umSpPageAuthSelector,
    umSpPageHasSubscriptionsTableSelector,
} from "../../_shared/selectors";
import {
    hasConsentsOnSubscriptionPreferencesAction,
    showErrorOnSubscriptionPreferencesAction,
} from "../../subscriptionPreferences/subscriptionPreferencesActions";

export function* loadConsentsSaga() {
    let action;
    while (
        (action = yield take([
            subscriptionPreferencesAT.hasScheme,
            subscriptionPreferencesAT.revertData,
        ]))
    ) {
        yield call(
            loadConsents,
            action.type === subscriptionPreferencesAT.hasScheme
        );
    }
}

const selector = (s: IState) => {
    const auth = umSpPageAuthSelector(s);

    return {
        token: auth?.token,
        user: auth?.user,
        userId: auth?.userRecordInfo?.itemId,
        hasSubscriptionsTable: umSpPageHasSubscriptionsTableSelector(s),
    };
};

const consentTemplate = {
    emailconsent: false,
    postconsent: false,
    pushconsent: false,
    smsconsent: false,
};

export function* loadConsents(fromUser = true) {
    const { token, user, userId, hasSubscriptionsTable } = yield select(
        selector
    );

    const [hasConsents, consents] = yield fromUser
        ? [true, selectFomUser(user)]
        : getJsonSaga(token, "v1/Profile/object/__consent/data?count=10");

    const [
        [hasSubscriptions, subscriptions],
        [hasUserSubscriptions, userSubscriptions],
    ] = hasSubscriptionsTable
        ? yield all([
              getJsonSaga(
                  token,
                  "v1/Profile/object/subscriptions/data?count=1000"
              ),
              getJsonSaga(
                  token,
                  "v1/Profile/object/__usersubscriptions/data?count=10000"
              ),
          ])
        : [
              [true, []],
              [true, []],
          ];

    if ([hasConsents, hasSubscriptions, hasUserSubscriptions].some(x => !x)) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                `inrernalError: has no subscriptions\n${JSON.stringify({
                    hasConsents,
                    hasSubscriptions,
                    hasUserSubscriptions,
                })}`,
                true
            )
        );
    } else {
        yield put(
            hasConsentsOnSubscriptionPreferencesAction(
                consents[0],
                subscriptions,
                userSubscriptions,
                userId
            )
        );
    }
}

const selectFomUser = user => [
    Object.keys(consentTemplate).reduce(
        (s, k) => ((s[k] = user[k] ?? false), s),
        {}
    ),
];
